const accountingEditVariants = Object.freeze({
  BILL_MISSING: 'bill_missing',
  INVOICE_MATCHING: 'invoice_matching',
  VENDOR_MISSING: 'vendor_missing',
});

const billInvoiceSourceConstants = Object.freeze({
  BACKEND: 'backend',
  EPR: 'epr',
});

const billInvoiceStatusConstants = Object.freeze({
  CONFIRMED: 'confirmed',
  PAID: 'paid',
});

const billInvoiceSyncStatusConstants = Object.freeze({
  ALL: 'all',
  ERROR: 'error',
  IN_PROGRESS: 'in_progress',
  NONE: 'none',
  SUCCESS: 'success',
});

const journalEntryStatusesConstants = Object.freeze({
  ACTIVE: 'active',
  MISSING_DATA: 'missing_data',
  READY_FOR_REVIEW: 'ready_for_review',
  READY_FOR_SUBMISSION: 'ready_for_submission',
  SUBMITTED: 'submitted'
});

const journalEntrySyncStatusConstants = Object.freeze({
  ERROR: 'error',
  IN_PROGRESS: 'in_progress',
  SUCCESS: 'success',
});

const vendorSyncStatusConstants = Object.freeze({
  ALL: 'all',
  ERROR: 'error',
  IN_PROGRESS: 'in_progress',
  NONE: 'none',
  SUCCESS: 'success',
});

const vendorSourceConstants = Object.freeze({
  BACKEND: 'backend',
  M3G_NETSUITE: 'm3g_netsuite',
});

export {
  accountingEditVariants,
  billInvoiceSourceConstants,
  billInvoiceStatusConstants,
  billInvoiceSyncStatusConstants,
  journalEntryStatusesConstants,
  journalEntrySyncStatusConstants,
  vendorSyncStatusConstants,
  vendorSourceConstants,
};

